import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpEventType,
  HttpHeaders,
} from '@angular/common/http';
import { lastValueFrom, filter, tap, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { decodeJWT } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root',
})
export class HttpAuthHelperService {
  constructor(
    private http: HttpClient
  ) { }

  async requestPromise(
    method: string,
    url: string,
    body?: any,
    params?: any
  ): Promise<any> {
    const headers = new HttpHeaders({
      ...(body instanceof FormData
        ? {}
        : { 'Content-Type': 'application/json' })
    });

    const options = {
      headers,
      params,
      body: body,
    } as any;

    const observable$ = this.http.request(method, url, options);

    return lastValueFrom(
      observable$.pipe(
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      )
    );
  }

  private async performRequest(
    method: string,
    url: string,
    body: any,
    params: any,
    onProgress?: (progress: number) => void
  ): Promise<any> {
    const headers = new HttpHeaders({
      ...(body instanceof FormData
        ? {}
        : { 'Content-Type': 'application/json' })
    });

    const options = {
      headers,
      params,
      reportProgress: !!onProgress,
      observe: 'events',
      body: body,
    } as any;

    const observable$ = this.http.request(method, url, options);

    return lastValueFrom(
      observable$.pipe(
        filter(
          (event: any) =>
            event.type === HttpEventType.Response ||
            event.type === HttpEventType.UploadProgress ||
            event.type === HttpEventType.DownloadProgress
        ),
        tap((event) => {
          if (
            onProgress &&
            event.total > 0 &&
            (event.type === HttpEventType.UploadProgress ||
              event.type === HttpEventType.DownloadProgress)
          ) {
            onProgress(Math.round((100 * event.loaded) / event.total));
          }
        }),
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      )
    );
  }

  async requestWithProgressPromise(
    method: string,
    url: string,
    onProgress: (progress: number) => void,
    body?: any,
    params?: any
  ): Promise<any> {
    // Simple implementation without refresh endpoint check for now
    return this.performRequest(
      method,
      url,
      body,
      params,
      onProgress
    );
  }
}
